class Enum {
     ROLE = {"M":"Manager","A":"Admin","U":"User","G":"Guest"};

     YES_NO = {0:"No",1:"Yes"};

     MEDICAL_STATUS = {0:"NG",1:"OK"};

     GENDER = {"M":"男Male","F":"女性Female"};

     BLOOD_TYPE = ["O","A","B","AB"];

     RELIGION = {0:"Buddhism",1:"Hinduism",2:"Islam",3:"Christian",4:"Other minority religions"};

     EDU_GRADE = {"M":"Junior High School Graduate / Middle School Graduate","H":"High School Graduate","U":"University Graduate / Bachelor’s Degree Holder","V":"Vocational School Graduate / Technical College Graduate"};

     PASSPORT_TYPE = ["PJ","PV","PS","PE","PR","PB","PT","PP"];

     HANDEDNESS = {"R":"Right","L":"Left"};

     MARITAL_STATUS = {"S":"未婚Single","M":"既婚Married"};

     INTERVIEW_STATUS = {"P":"Pass","N":"No"};

    EYESIGHT_VALUES = [1.0, 0.8, 0.5, 0.3];
}
export default Enum;
